// @flow

import React from 'react';
import { withRouter } from 'react-router-dom';
import { kpiImage } from '../../../../../const';

type Props = {
  kpis: any,
}

type State = {
  steps: any,
}

class EventKpi extends React.PureComponent<Props, State> {
  render() {
    const { kpis } = this.props;
    return (
      <React.Fragment>
        {
          !!kpis ?
            kpis
              .sort((a, b) => a.order - b.order)
              .filter((a) => (!!a.value))
              .map((kpi) => {
                return (
                  <div className="activities-item" key={kpi.id}>
                    <span title={kpi.description}>
                      <div className="activities-item-circle activities-item-developer">
                        <img src={kpiImage[kpi.icon]} alt="KPI of event" />
                      </div>
                      <p className="activities-item-value">{kpi.value}</p>
                      <p className="activities-item-label">{kpi.label}</p>
                    </span>
                  </div>
                );
              })
            : <div></div>
        }
      </React.Fragment>
    );
  }
}

export default withRouter(EventKpi);
